// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#report-map-container {
  width: 100%;
  height: calc(100vh - 150px);
}
#report-map-container div {
  width: 100%;
  height: calc(100vh - 150px);
  z-index: 0;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/risk-forecasting/components/risk-forecast-map.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,2BAAA;AACJ;AAAI;EACG,WAAA;EACA,2BAAA;EACC,UAAA;AAER","sourcesContent":["#report-map-container{\n    width: 100%;\n    height: calc(100vh - 150px);\n    div{\n       width: 100%;\n       height: calc(100vh - 150px);\n        z-index: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
